// Govern the search popup
(function($){
	$('#search-open').click(function(e) {
		$('#search-form').addClass('open');

		$('#header-search-input').focus();
	});

	$('#search-close').click(function(e) {
		$('#search-form').removeClass('open');

		$('#header-search-input').val('').blur();
	});
})(jQuery);
